import React from 'react';
import { render } from 'react-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectYourXDropdownToggle } from '../actions/selectYourXDropdownsActions';

class SelectYourXDropdown extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            typeAheadResults: []
        };
    }
    hasTypeAheadResults() {
        return this.state.typeAheadResults.length > 0;
    }
    handleChange(event) {
        let typeAheadResults = [];
        if (event.target.value) {
            let searchExpression = new RegExp(event.target.value, "i");
            typeAheadResults = this.props.arrayForSelection.filter(function (x) {
                return searchExpression.test(x.description);
            });
        }
        this.setState({ typeAheadResults: typeAheadResults });
    }
    onClick(filterDescription) {
        this.props.selectYourXDropdownToggle(this.props.currentIndex);
        if (this.props.callBack) {
            this.props.callBack(filterDescription);
        }
    }
    createLIElement(filterValue) {
        return (
            <li key={filterValue.description}>
                {this.props.urlPrefix ?
                    <a href={this.props.urlPrefix + encodeURIComponent(filterValue.description) + (this.props.urlSuffix || '')}>
                        {filterValue.description}
                    </a>
                    :
                    <Link to={{ pathname: '/' + (this.props.routePrefix || '') + encodeURIComponent(filterValue.description), search: this.props.queryString }} onClick={() => this.onClick(filterValue.description)}>
                        {filterValue.description}
                    </Link>
                }
            </li>
        );
    }
    render() {
        let filterInputId = "refine" + this.props.selectYourXDropdownIndex;
        return (
            <div className='select-your-x-dropdown'>
                <label htmlFor={filterInputId} className="sr-only">{"refine" + this.props.filterPlaceholderText}</label>
                <input type="text"
                    id={filterInputId}
                    name={filterInputId}
                    onChange={this.handleChange}
                    placeholder={this.props.filterPlaceholderText} />
                {this.hasTypeAheadResults() ?
                    <div className="type-ahead-separator">
                        <ul>
                            {this.state.typeAheadResults.map(filterValue =>
                                this.createLIElement(filterValue)
                            )}
                        </ul>
                        <hr className="blue narrow" />
                    </div>
                    :
                    null
                }
                <ul>
                    {this.props.arrayForSelection.map(filterValue =>
                        this.createLIElement(filterValue)
                    )}
                </ul>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        selectYourXDropdowns: state.selectYourXDropdowns
    };
}
function mapDispatchToProps(dispatch) {
    return {
        selectYourXDropdownToggle: (e) => dispatch(selectYourXDropdownToggle(e))
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectYourXDropdown);